import React, { useMemo, useState } from "react";
import { validateFormula, calculateLikeDesktop } from "helpers/estimatingDatabase/jaceFormula";

// Formula input with the desktop's own parser behind it: the formula is
// accepted here exactly when the desktop estimating app accepts it.
export const FormulaEditor = ({ value, onChange, error: externalError }) => {
  const check = useMemo(() => (value ? validateFormula(value) : null), [value]);
  const [testValues, setTestValues] = useState({});

  const missingOnDesktop = check && check.valid
    ? check.variables.filter((v) => !check.desktopVariables.includes(v))
    : [];

  const result =
    check && check.valid
      ? calculateLikeDesktop(
          check.ast,
          Object.fromEntries(check.desktopVariables.map((v) => [v, Number(testValues[v]) || 0]))
        )
      : null;

  return (
    <div data-testid="formula-editor">
      <textarea
        className="form-control"
        rows={3}
        value={value || ""}
        placeholder="e.g. (length * width) / 144 + waste"
        onChange={(e) => onChange(e.target.value)}
        aria-label="Formula"
      />
      {check && !check.valid && (
        <div className="text-danger f-12 mt-1" data-testid="formula-error">
          {check.error}
        </div>
      )}
      {externalError && !(check && !check.valid) && (
        <div className="text-danger f-12 mt-1">{externalError}</div>
      )}
      {check && check.valid && (
        <div className="mt-2 f-12">
          <div className="text-success" data-testid="formula-ok">
            Valid formula
          </div>
          <div className="text-muted mb-1">
            Operators: + - * / ^ % and comparisons (&lt; &gt; &lt;= &gt;= == != &amp;&amp; ||). Functions are not available.
          </div>
          {check.desktopVariables.length > 0 && (
            <div className="d-flex flex-wrap gap-2 align-items-center">
              <span>Try it:</span>
              {check.desktopVariables.map((v) => (
                <label key={v} className="d-flex align-items-center gap-1 mb-0">
                  {v}
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ width: 90 }}
                    value={testValues[v] === undefined ? "" : testValues[v]}
                    onChange={(e) => setTestValues((t) => ({ ...t, [v]: e.target.value }))}
                  />
                </label>
              ))}
            </div>
          )}
          <div className="mt-1" data-testid="formula-result">
            Result: {Number.isFinite(result) ? result.toLocaleString(undefined, { maximumFractionDigits: 6 }) : String(result)}
          </div>
          {missingOnDesktop.length > 0 && (
            <div className="text-warning mt-1">
              {missingOnDesktop.join(", ")} only appear under a leading minus sign, % or a comparison; the estimating app cannot
              map them to a model parameter, so the formula evaluates to 0 there.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
